@if (data$ | async; as data) {
	<adf-page-template>
		<div icon>
			<i class="{{ data['icon'] }} page-icons"></i>
		</div>
		<div status>
			{{ data['status'] }}
		</div>
		<div title>
			{{ data['title'] }}
		</div>
		<div description>
			{{ data['description'] }}
		</div>
		@if (data['url']) {
			<div button>
				<a [routerLink]="data['url']" class="btn btn-primary">{{ data['label'] }}</a>
			</div>
		}
	</adf-page-template>
}
